import { parseISO } from 'date-fns'

import { CellRendererParams } from '../EntityTable/types'
import { Badge } from '@/Atomic/Atoms/Badge'
import { ensureString } from '@/utils/ensureString'
import { formatDurationShort } from '@/utils/formatDuration'

export const ActivityDurationBadge = ({ dataItem }: CellRendererParams) => {
  const duration = formatDurationShort(
    parseISO(ensureString(dataItem.get('beginAt'))),
    parseISO(ensureString(dataItem.get('endAt'))),
    3,
  )
  if (!duration) return null
  return <Badge variant="white" value={duration} />
}
